import React from "react";
import axios from "axios";
import "../../css/table.css";
import ReactTable from "react-table";
import { connect } from "react-redux";
import UserForm from "../../forms/UserForm.jsx";
import { toArray, orderBy } from "lodash";
import Card from "../../components/Card/Card.jsx";
import { resetForm } from "../../ducks/Forms";
import Modal from "../../components/Modal/Modal.jsx";
import PasswordForm from "../../forms/PasswordForm.jsx";
import { db, auth } from "../../services/firebase";
import SweetAlert from "react-bootstrap-sweetalert";
import NotificationSystem from "react-notification-system";
import Button from "../../elements/CustomButton/CustomButton.jsx";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import SweetSpinner from "../../components/SweetSpinner/SweetSpinner.jsx";
import { style as NotifyStyle } from "../../variables/Variables.jsx";
import { Grid, Col, Row, OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  faKey,
  faTrash,
  faLock,
  faEdit,
  faUnlock,
} from "@fortawesome/fontawesome-free-solid";

class Users extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      users: {},
      loading: false,
      userModal: false,
      passwordModal: false,
      alert: null,
      _notificationSystem: null,
      targetUser: null,
    };
  }

  componentDidMount() {
    this._fetch();
    this.setState({ _notificationSystem: this.refs.notificationSystem });
  }

  render() {
    return (
      <div className="main-content">
        {this.userModal()}
        {this.passwordModal()}
        {this.state.alert}
        <NotificationSystem ref="notificationSystem" style={NotifyStyle} />
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Button
                bsStyle="default"
                wd
                className="pull-right"
                style={{ marginBottom: 10 }}
                onClick={() => {
                  this.props.resetForm("UserForm");
                  this.setState({ userModal: true, targetUser: null });
                }}
              >
                Adicionar Usuário
              </Button>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Card
                content={
                  <ReactTable
                    columns={[
                      { Header: "Nome", accessor: "name" },
                      { Header: "Empresa", accessor: "companyName" },
                      { Header: "Turno", accessor: "shiftDetails" },
                      { Header: "Acesso", accessor: "roleName" },
                      {
                        Header: "Ações",
                        accessor: "",
                        Cell: ({ value }) => (
                          <div style={{ textAlign: "center" }}>
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip id={`edit_${value.id}`}>
                                  Editar
                                </Tooltip>
                              }
                            >
                              <a
                                className="btn btn-simple btn-default btn-icon"
                                onClick={() =>
                                  this.setState({
                                    targetUser: {
                                      ...value,
                                      password: "123456",
                                    },
                                    userModal: true,
                                  })
                                }
                              >
                                <FontAwesomeIcon
                                  className="text-dark"
                                  icon={faEdit}
                                />
                              </a>
                            </OverlayTrigger>
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip id={`password_${value.id}`}>
                                  Alterar Senha
                                </Tooltip>
                              }
                            >
                              <a
                                className="btn btn-simple btn-default btn-icon"
                                onClick={() =>
                                  this.setState({
                                    targetUser: {
                                      ...value,
                                      password: "123456",
                                    },
                                    passwordModal: true,
                                  })
                                }
                              >
                                <FontAwesomeIcon
                                  className="text-dark"
                                  icon={faKey}
                                />
                              </a>
                            </OverlayTrigger>

                            {value.id !== this.props.user.id && (
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Tooltip id={`switch_status_${value.id}`}>
                                    {value.active
                                      ? "Bloquear Acesso"
                                      : "Desbloquear Acesso"}
                                  </Tooltip>
                                }
                              >
                                <a
                                  className="btn btn-simple btn-default btn-icon"
                                  onClick={() =>
                                    this.lockUnlockUserAlert(value)
                                  }
                                >
                                  {value.active ? (
                                    <FontAwesomeIcon
                                      className="text-dark"
                                      icon={faLock}
                                    />
                                  ) : (
                                    <FontAwesomeIcon
                                      className="text-dark"
                                      icon={faUnlock}
                                    />
                                  )}
                                </a>
                              </OverlayTrigger>
                            )}
                            {value.id !== this.props.user.id && (
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Tooltip id={`remove_${value.id}`}>
                                    Remover
                                  </Tooltip>
                                }
                              >
                                <a
                                  className="btn btn-simple btn-danger btn-icon"
                                  onClick={() => this.removeUserAlert(value)}
                                >
                                  <FontAwesomeIcon icon={faTrash} />
                                </a>
                              </OverlayTrigger>
                            )}
                          </div>
                        ),
                      },
                    ]}
                    data={orderBy(toArray(this.state.users), ["name", "asc"])}
                    onFetchData={this._fetch}
                    loading={this.state.loading}
                    defaultPageSize={10}
                    className="-striped -highlight"
                    previousText="Anterior"
                    nextText="Próximo"
                    loadingText="Carregando"
                    noDataText="Nenhum registro encontrado"
                    pageText="Página"
                    ofText="de"
                    rowsText="Registros"
                  />
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }

  //Data handlers
  _fetch = () => {
    this.setState({ loading: true });
    let users = {};
    const PromiseStack = [];

    db.collection("users")
      .get()
      .then((userSnapshot) => {
        userSnapshot.forEach((user) => {
          users[user.id] = user.data();

          //companyName, roleName and shiftDetails are only facades
          PromiseStack.push(
            db
              .collection("companies")
              .doc(user.data().company)
              .get()
              .then(
                (companySnapshot) =>
                  (users[user.id].companyName = companySnapshot.data().name)
              )
          );

          PromiseStack.push(
            db
              .collection("roles")
              .doc(user.data().role)
              .get()
              .then(
                (roleSnapshot) =>
                  (users[user.id].roleName = roleSnapshot.data().name)
              )
          );

          if (user.data().shift) {
            if (user.data().shift.value) {
              PromiseStack.push(
                db
                  .collection("companies")
                  .doc(user.data().company)
                  .collection("shifts")
                  .doc(user.data().shift.value)
                  .get()
                  .then(
                    (shiftSnapshot) =>
                      (users[user.id].shiftDetails = `${
                        shiftSnapshot.data().name
                      }`)
                  )
              );
            } else {
              PromiseStack.push(
                db
                  .collection("companies")
                  .doc(user.data().company)
                  .collection("shifts")
                  .doc(user.data().shift)
                  .get()
                  .then(
                    (shiftSnapshot) =>
                      (users[user.id].shiftDetails = `${
                        shiftSnapshot.data().name
                      }`)
                  )
              );
            }
          } else {
            users[user.id].shiftDetails = "Indefinido";
          }
        });

        Promise.all(PromiseStack)
          .then(() => this.setState({ loading: false, users }))
          .catch((e) => {
            console.log("promise.all error: ", e);
            this.notify("Erro ao buscar detalhes dos usuários", "error");
            this.setState({ loading: false, users });
          });
      })
      .catch((e) => {
        console.log(e);
        this.notify("Erro ao buscar usuários", "error");
        this.setState({ loading: false, users });
      });
  };

  _set = (values) => {
    this.setState({ userModal: false });
    this.waitAlert("Adicionando usuário", true);
    const { name, email, password, role, company } = values;

    auth
      .createUserWithEmailAndPassword(email, password)
      .then((newUser) => {
        db.collection("users")
          .doc(newUser.uid)
          .set({
            name,
            email,
            role: role.value,
            company: company.value,
            id: newUser.uid,
            shift: values.shift ? values.shift.value : null,
            active: true,
          })
          .then(() => {
            this._updateCompanyUsers(company.value)("add");
            this.hideAlert();
            this.notify("Usuário adicionado", "success");
            this._fetch();
          })
          .catch((e) => {
            this.hideAlert();
            this.notify("Erro ao adicionar usuário", "error");
            this._fetch();
          });
      })
      .catch((e) => {
        switch (e.code) {
          case "auth/email-already-in-use":
            this.hideAlert();
            this._fetch();
            return this.notify("O email informado já está em uso", "warning");
          default:
            this.hideAlert();
            this._fetch();
            return this.notify("Erro ao criar a conta do usuário", "error");
        }
      });
  };

  _update = (id) => (values) => {
    this.setState({ userModal: false });
    this.waitAlert("Atualizando dados", true);
    const { name, email, role, company } = values;

    //look for company update
    if (typeof company === "object") {
      //updates (or not) the total company users
      if (company.value !== this.state.targetUser.company) {
        this._updateCompanyUsers(this.state.targetUser.company)("remove");
        this._updateCompanyUsers(company.value)("add");
      }
    }

    if (email !== this.state.targetUser.email) {
      axios
        .put(
          "https://us-central1-integrar-5ee17.cloudfunctions.net/updateEmail",
          { id, newEmail: email }
        )
        .then(() => {
          db.collection("users")
            .doc(id)
            .update({ email })
            .then(() => {
              this.notify(
                `O endereço de email será atualizado em até 5 minutos.`,
                "success"
              );
              this._fetch();
            })
            .catch((e) =>
              this.notify(`Endereço de email inválido ou em uso.`, "error")
            );
        })
        .catch((e) =>
          this.notify(`Endereço de email inválido ou em uso.`, "error")
        );
    }

    db.collection("users")
      .doc(id)
      .update({
        name,
        role: typeof role === "object" ? role.value : role,
        company: typeof company === "object" ? company.value : company,
        shift: values.shift
          ? typeof values.shift.value === "object"
            ? values.shift.value
            : values.shift
          : null,
      })
      .then(() => {
        this.hideAlert();
        this._fetch();
        this.notify(`Usuário(a) ${name} atualizado(a).`, "success");
      })
      .catch((e) => {
        this.hideAlert();
        this._fetch();
        this.notify(`Erro ao atualizar as informações de ${name}.`, "error");
      });
  };

  _updateCompanyUsers = (companyID) => (operation) => {
    db.collection("companies")
      .doc(companyID)
      .get()
      .then((doc) => {
        if (doc.exists) {
          let users =
            operation === "add" ? doc.data().users + 1 : doc.data().users - 1;
          db.collection("companies")
            .doc(companyID)
            .update({ users })
            .then(() => console.log("Company users updated!"))
            .catch((e) => console.log("Error while updating company users"));
        } else {
          console.log("This company doesn`t exists! How you did this?");
        }
      })
      .catch((e) => console.log("Firestore read error!"));
  };

  _remove = (user) => {
    this.hideAlert();
    this.waitAlert("Validando dados, aguarde", false);
    db.collection("companies")
      .doc(user.company)
      .collection("results")
      .where(
        `${user.roleName === "Coletor" ? "user" : "justifiedBy"}`,
        "==",
        user.id
      )
      .get()
      .then((snap) => {
        if (snap.empty) {
          this.hideAlert();
          this.waitAlert("Removendo usuário, aguarde", false);
          db.collection("users")
            .doc(user.id)
            .delete()
            .then(() => {
              this._updateCompanyUsers(user.company)("remove");
              this.hideAlert();
              this._fetch();
              this.notify(
                "Usuário removido. Os dados de acesso serão revogados em até 24 horas.",
                "success"
              );
            })
            .catch((e) => {
              this.hideAlert();
              this._fetch();
              this.notify("Erro ao remover o usuário.", "error");
            });
        } else {
          this.hideAlert();
          this._fetch();
          this.notify(
            "Este usuário possui ligações com os dados da empresa e não pode ser removido.",
            "warning"
          );
        }
      });
  };

  _updatePassword = (id) => (newPassword) => {
    axios
      .put(
        "https://us-central1-integrar-5ee17.cloudfunctions.net/updatePassword",
        { id, newPassword }
      )
      .then((response) => console.log(response))
      .catch((e) => console.log(e));
  };

  _lockAccount = (id) => {
    this.hideAlert();
    this.waitAlert("Bloqueando, aguarde", false);

    db.collection("users")
      .doc(id)
      .update({ active: false })
      .then(() => {
        axios
          .put(
            "https://us-central1-integrar-5ee17.cloudfunctions.net/lockAccount",
            { id }
          )
          .then((response) => {
            this.hideAlert();
            this._fetch();
            this.notify(
              "Acesso bloqueado. As alterações podem demorar até 5 minutos para surtirem efeito.",
              "success"
            );
          })
          .catch((e) => {
            this.hideAlert();
            this._fetch();
            this.notify("Erro ao bloquear acesso.", "danger");
          });
      })
      .catch((e) => {
        this.hideAlert();
        this._fetch();
        this.notify("Erro ao bloquear acesso.", "danger");
      });
  };

  _unlockAccount = (id) => {
    this.hideAlert();
    this.waitAlert("Desbloqueando, aguarde", false);

    db.collection("users")
      .doc(id)
      .update({ active: true })
      .then(() => {
        axios
          .put(
            "https://us-central1-integrar-5ee17.cloudfunctions.net/unlockAccount",
            { id }
          )
          .then((response) => {
            this.hideAlert();
            this._fetch();
            this.notify(
              "Acesso desbloqueado. As alterações podem demorar até 5 minutos para surtirem efeito.",
              "success"
            );
          })
          .catch((e) => {
            this.hideAlert();
            this._fetch();
            this.notify("Erro ao desbloquear acesso.", "danger");
          });
      })
      .catch((e) => {
        this.hideAlert();
        this._fetch();
        this.notify("Erro ao desbloquear acesso.", "danger");
      });
  };

  //Notifications
  notify = (message, level) => {
    this.state._notificationSystem.addNotification({
      title: null,
      message: <b>{message}</b>,
      level,
      position: "tr",
      autoDismiss: 4,
    });
  };

  //SweetAlerts
  hideAlert = () => this.setState({ alert: null });

  removeUserAlert = (user) => {
    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block" }}
          title="Tem certeza?"
          onConfirm={() => this._remove(user)}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="default"
          cancelBtnBsStyle="warning"
          confirmBtnText="Continuar"
          cancelBtnText="Cancelar"
          showCancel
        >
          Todos os dados do usuário serão removidos
        </SweetAlert>
      ),
    });
  };

  lockUnlockUserAlert = (user) => {
    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block" }}
          title="Tem certeza?"
          onConfirm={() =>
            user.active
              ? this._lockAccount(user.id)
              : this._unlockAccount(user.id)
          }
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="default"
          cancelBtnBsStyle="warning"
          confirmBtnText="Continuar"
          cancelBtnText="Cancelar"
          showCancel
        >
          {user.active
            ? "O usuário terá seu acesso revogado"
            : "O usuário terá seu acesso restituído"}
        </SweetAlert>
      ),
    });
  };

  waitAlert = (title, showSpinner) => {
    this.setState({
      alert: (
        <SweetAlert
          style={{ display: "block" }}
          title={title}
          onConfirm={() => null}
          showConfirm={false}
        >
          {showSpinner ? <SweetSpinner /> : null}
        </SweetAlert>
      ),
    });
  };

  //Conditional rendering
  userModal = () => {
    this.props.resetForm("PasswordForm");
    const { targetUser } = this.state;
    return (
      <Modal
        className="modal__medium"
        title={targetUser ? "Atualizar usuário" : "Adicionar usuário"}
        isOpen={this.state.userModal}
        content={
          <UserForm
            initialValues={this.state.targetUser}
            onSubmit={(values) => {
              targetUser
                ? this._update(targetUser.id)(values)
                : this._set(values);
            }}
            handleCancel={() => this.setState({ userModal: false })}
          />
        }
      />
    );
  };

  passwordModal = () => {
    const { targetUser } = this.state;
    return (
      <Modal
        title="Alterar senha"
        isOpen={this.state.passwordModal}
        size="modal__small"
        content={
          <PasswordForm
            onSubmit={(values) => {
              this.setState({ passwordModal: false });
              this.waitAlert("Aguarde", true);
              axios
                .put(
                  "https://us-central1-integrar-5ee17.cloudfunctions.net/updatePassword",
                  { id: targetUser.id, newPassword: values.password }
                )
                .then(() => {
                  this.hideAlert();
                  this.notify(
                    `A senha será atualizada em até 5 minutos.`,
                    "success"
                  );
                })
                .catch((e) => {
                  this.hideAlert();
                  this.notify(`Erro ao atualizar a senha.`, "danger");
                });
            }}
            handleCancel={() => this.setState({ passwordModal: false })}
          />
        }
      />
    );
  };
}

const mapStateToProps = (state) => ({ user: state.auth.user });

export default connect(mapStateToProps, { resetForm })(Users);



// WEBPACK FOOTER //
// ./src/views/Users/Users.jsx